import axios from 'axios';
import { baseUrlDev, urlApiAsesoria } from '../Config/baseUrl';
import { IActualizarVideoVisto, IUser } from '../Interfaces/IUser';
// import { IFormUsuario } from '../Interfaces/IFormUsuario';

// const baseURL = baseUrlProduction;

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const actualizarVideoVisto = (data: IActualizarVideoVisto) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/actualizarVideoVisto', data, config);
};
